
const requiredValidator = (value: any) => { 
     return (value ? undefined : 'Required')
}

export default requiredValidator;